<template>
  <div :class="$style.list">
    <FaqSingleItem
      v-for="(question, index) of questions"
      :key="index"
      :title="question?.title?.rendered || ''"
      :content="question?.content?.rendered || ''"
    />
  </div>
</template>

<script setup lang="ts">
import type { FaqParams } from './index.js';

defineProps<FaqParams>();
</script>

<style lang="scss" module>
  .list {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
</style>